import type { ConstructionTypeData, ContractSeasonData } from 'gql/graphql';
import { Button } from 'uikit';
import { getCheckedIdsArr } from 'utils';

import { useCallback, useMemo, useState } from 'react';

import { AgreementsAddTable } from '../AgreementsAddTable';
import { useAddOtherAgreements } from '../hooks/useAddOtherAgreements';
import { useAgreementTableAddOther } from '../hooks/useAgreementTableAddOther';

interface IAgreementsAddOtherProps {
    refreshAgreementsOther: () => void;
    refreshFilters: () => void;
    disabledByStatus: boolean;
    isDisabledByProjectStatus: boolean;
    isDisabledByContractStatus: boolean;
    contractId: number;
    agreementId: number;
    contractSeasons: ContractSeasonData[];
    contractConstructionTypes: ConstructionTypeData[];
}

export const AgreementsAddOther = ({
    refreshAgreementsOther,
    refreshFilters,
    disabledByStatus,
    isDisabledByProjectStatus,
    isDisabledByContractStatus,
    contractId,
    agreementId,
    contractSeasons,
    contractConstructionTypes,
}: IAgreementsAddOtherProps) => {
    const [openModal, setOpenModal] = useState<boolean>(false);

    const {
        titleModal,
        checkedIds,
        setCheckedIds,
        agreementsData,
        agreementsStatus,
        agreementsErrors,
        finalColumns,
        isSubmittedDataTable,
        handleCloseErrorAgreementTable,
        dataSource,
    } = useAgreementTableAddOther(openModal, disabledByStatus, contractId, contractSeasons, contractConstructionTypes);

    const {
        titleAddError,
        addOtherAgreementsData,
        addOtherAgreementsStatus,
        addOtherAgreementsError,
        isSubmittedAddOther,
        handleAddOtherAgreements,
        handleCloseErrorModalAddRatio,
        handleCreateReportAddOther,
    } = useAddOtherAgreements(
        checkedIds,
        setCheckedIds,
        refreshAgreementsOther,
        setOpenModal,
        refreshFilters,
        agreementId,
    );

    const handleOpenModal = useCallback(() => setOpenModal(true), []);
    const handleCloseModal = useCallback(() => {
        setCheckedIds({});
        setOpenModal(false);
    }, [setCheckedIds]);

    const isConfirmDisabled = useMemo(() => !getCheckedIdsArr(checkedIds).length, [checkedIds]);

    return (
        <>
            <Button
                label="Добавить прочие"
                size="s"
                view="secondary"
                onClick={handleOpenModal}
                disabled={disabledByStatus || isDisabledByProjectStatus || isDisabledByContractStatus}
            />
            {openModal && (
                <AgreementsAddTable
                    titleModal={titleModal}
                    handleCloseAddAgreements={handleCloseModal}
                    tableColumns={finalColumns}
                    isSubmittedAddMtr={isSubmittedAddOther}
                    addAgreementsStatus={addOtherAgreementsStatus}
                    addAgreementsData={addOtherAgreementsData}
                    addAgreementsError={addOtherAgreementsError}
                    handleAddAgreements={handleAddOtherAgreements}
                    handleCloseErrorModalAdd={handleCloseErrorModalAddRatio}
                    handleCreateReportAdd={handleCreateReportAddOther}
                    titleAddError={titleAddError}
                    isSubmittedDataTable={isSubmittedDataTable}
                    agreementsStatus={agreementsStatus}
                    agreementsData={agreementsData}
                    agreementsErrors={agreementsErrors}
                    handleCloseErrorAgreementTable={handleCloseErrorAgreementTable}
                    dataSource={dataSource}
                    isConfirmDisabled={isConfirmDisabled}
                    isShowSearch={false}
                    rowClassRules={{
                        groupRow: ({ data }) => (data as any)?.type === 'section',
                        defaultRowClass: ({ data }) => (data as any)?.type !== 'section',
                    }}
                />
            )}
        </>
    );
};

AgreementsAddOther.displayName = 'AgreementsAddOther';
